import type { ReactNode } from "react";
import { RequestList } from "@/components/shared/RequestList/RequestList";
import { useIncentiveRequests } from "@/hooks/useIncentiveRequests";
import { useFileDownload } from "@/hooks/useFileDownload";
import styles from "./MyRequestsPage.module.scss";

export function MyRequestsPage(): ReactNode {
  const { requests, isLoading, error } = useIncentiveRequests();
  const { downloadingId, error: downloadError, download, clearError } = useFileDownload();

  if (isLoading) {
    return (
      <div className={styles.loadingState} role="status" aria-label="Loading requests">
        <div className={styles.spinner} />
        <p className={styles.loadingMessage}>Loading requests...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.errorState} role="alert">
        <span>Failed to load requests. Please try again later.</span>
      </div>
    );
  }

  return (
    <div className={styles.pageWrapper}>
      {downloadingId && (
        <div className={styles.downloadOverlay} role="status" aria-label="Downloading file">
          <div className={styles.spinner} />
          <p className={styles.loadingMessage}>Downloading...</p>
        </div>
      )}
      <RequestList
        requests={requests}
        onDownload={download}
        downloadingId={downloadingId}
        downloadError={downloadError}
        onDismissError={clearError}
      />
    </div>
  );
}
